import { render, staticRenderFns } from "./SearchUserComponent.vue?vue&type=template&id=fd56f6ca&"
import script from "./SearchUserComponent.vue?vue&type=script&lang=js&"
export * from "./SearchUserComponent.vue?vue&type=script&lang=js&"
import style0 from "./SearchUserComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports